import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BotaoCadastro from '../../../Componentes/BotaoCadastro';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import ModalView, { ModalTópico } from '../../../Componentes/ModalView';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import PesquisaInput from '../../../Componentes/PesquisaInput';
import TabelaComponente from '../../../Componentes/TabelaComponente';
import { FixedInput } from '../../../Componentes/TextInput';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import '../../../Estilos/EstiloBotao.css';
import { apiService } from '../../../Services/ApiService';
import { StoreContexto } from '../../../Contexto/Provider';
import useDebounce from '../../../Hooks/debouceSearch';
import { useTranslation } from 'react-i18next';

function UsuariosLista() {
  const navigate = useNavigate();
  const { t: tRoles } = useTranslation('roles');
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [user, setUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [searchText, setSearchText] = useState('');
  const debounceSearch = useDebounce(searchText, 500);
  const [page, setPage] = useState(0);

  const [menuOptions, setMenuOptions] = useState(['Visualizar']);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    visible: false,
    message: '',
    operation: '',
    id: '',
  });
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });

  const { get, put } = apiService();
  const { auth } = useContext(StoreContexto);

  useEffect(() => {
    getUsers();
  }, [page]);

  useEffect(() => {
    if (auth.perfilSalvo === 'OWNER') {
      setMenuOptions(['Visualizar', 'Ativar/Inativar']);
    }
  }, [auth]);

  useEffect(() => {
    getUsers(debounceSearch);
  }, [debounceSearch]);

  const getUsers = async (currentSearchText = '') => {
    const queryParams = { page, size: 10, search: currentSearchText };
    setIsLoading(true);
    try {
      const data = await get('users', queryParams);
      if (data) {
        setUsers(data.result || []);
        setTotalUsers(data.total || 0);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar usuários' });
    } finally {
      setIsLoading(false);
    }
  };

  const getUserById = async (userId) => {
    setIsLoading(true);
    try {
      const user = await get(`users/${userId}`);
      setUser(user);
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar usuário' });
    } finally {
      setIsLoading(false);
    }
  };

  const setUserDisabled = async (userId) => {
    setIsLoading(true);
    try {
      await put(`users/disable/${userId}`);
      getUsers();
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao realizar operação' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (text) => {
    setSearchText(text);
  };

  const handleEditClick = (userId) => {
    navigate(`/user-form/${userId}`);
  };

  const handleMenuItemSelect = (userId, menuItem) => {
    const selectedUser = users.find((user) => user.id === userId);
    if (!selectedUser) return;

    switch (menuItem) {
      case 'Visualizar':
        getUserById(userId).then(() => setModalVisible(true));
        break;
      case 'Ativar/Inativar':
        const isDisabled = selectedUser.disabled;
        setModalConfirm({
          visible: true,
          message: `Deseja ${isDisabled ? 'ativar' : 'inativar'} o usuário?`,
          operation: isDisabled ? 'Ativar' : 'Inativar',
          id: userId,
        });
        break;
      default:
        break;
    }
  };

  const nextPage = async () => {
    setPage(page + 1);
  };

  const previousPage = async () => {
    setPage(page - 1);
  };

  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}

      {modalConfirm.visible && (
        <ModalConfirmacao
          aviso={modalConfirm.message}
          confirmar={false}
          clicado={() => {
            setUserDisabled(modalConfirm.id, modalConfirm.operation === 'Inativar');
            setModalConfirm({ visible: false, message: '', operation: '', id: '' });
          }}
          clicadoVolta={() =>
            setModalConfirm({ visible: false, message: '', operation: '', id: '' })
          }
        />
      )}

      {modalVisible && (
        <ModalView height={'100%'} width={'100%'}>
          <ModalTópico titulo="Visualizar Usuário" />
          <FixedInput titulo="Nome" padrao={user.name} disabled={true} tipo="text" />
          <FixedInput titulo="E-mail" padrao={user.email} disabled={true} tipo="text" />
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <FixedInput
              titulo="Controle"
              padrao={user.control}
              disabled={true}
              tipo="text"
              right={10}
            />
            <FixedInput
              titulo="Telefone"
              padrao={user.phone}
              disabled={true}
              tipo="text"
              left={10}
            />
          </div>
          <FixedInput titulo="Perfil" padrao={tRoles(user.role)} disabled={true} tipo="text" />
          <button style={{ margin: 30 }} id="BotaoCadastro" onClick={() => setModalVisible(false)}>
            Fechar
          </button>
        </ModalView>
      )}

      <div className="ContainerGeral">
        <TopicoTexto titulo="Lista de Usuários" />
        <BotaoCadastro
          visivel={auth.perfilSalvo === 'OWNER'}
          nome="Cadastrar"
          clicado={() => navigate('/user-form')}
        />
        <PesquisaInput placeholder="Insira o nome do usuário" onSearch={handleSearch} />
        <TabelaComponente
          colunas={['NOME', 'E-MAIL', 'CONTROLE', 'PERFIL', 'STATUS']}
          campos={['name', 'email', 'control', 'role', 'disabled']}
          linhas={users}
          paginaAtual={page}
          total={totalUsers}
          aviso={!users.length ? 'Nenhum usuário encontrado' : 'Buscando usuários...'}
          menuOptions={menuOptions}
          onEditClick={handleEditClick}
          onMenuItemSelect={handleMenuItemSelect}
          goToNextPage={nextPage}
          goToPreviousPage={previousPage}
          entity="users"
          role={auth.perfilSalvo}
        />
      </div>
    </CorpoPagina>
  );
}

export default UsuariosLista;
